import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3188e0ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fottball" }
const _hoisted_2 = {
  key: 0,
  class: "adbox"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "skname" }
const _hoisted_5 = { class: "skname-left" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1 /* HOISTED */))
const _hoisted_7 = { class: "skname-right" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1 /* HOISTED */))
const _hoisted_9 = { class: "circle flexcenter" }
const _hoisted_10 = { class: "circle-cent" }
const _hoisted_11 = { class: "circle-cent-sruin flexcenter" }
const _hoisted_12 = { class: "circle-cent" }
const _hoisted_13 = { class: "circle-cent-sruin flexcenter" }
const _hoisted_14 = { class: "circle-cent" }
const _hoisted_15 = { class: "circle-cent-sruin flexcenter" }
const _hoisted_16 = { class: "goal flexcenter" }
const _hoisted_17 = { class: "goal-left" }
const _hoisted_18 = { class: "goal-icon" }
const _hoisted_19 = { alt: "" }
const _hoisted_20 = { class: "goal-icon" }
const _hoisted_21 = { alt: "" }
const _hoisted_22 = { class: "goal-icon" }
const _hoisted_23 = { alt: "" }
const _hoisted_24 = { class: "goal-centent" }
const _hoisted_25 = { class: "goal-centent-box" }
const _hoisted_26 = { class: "goal-centent-box-bottom flexcenter" }
const _hoisted_27 = { class: "goal-crsall flexcenter" }
const _hoisted_28 = { class: "goal-crsall-left" }
const _hoisted_29 = { class: "goal-crsall-right" }
const _hoisted_30 = { class: "goal-centent-box" }
const _hoisted_31 = { class: "goal-centent-box-bottom flexcenter" }
const _hoisted_32 = { class: "goal-crsall flexcenter" }
const _hoisted_33 = { class: "goal-crsall-left" }
const _hoisted_34 = { class: "goal-crsall-right" }
const _hoisted_35 = { class: "goal-right" }
const _hoisted_36 = { class: "goal-icon" }
const _hoisted_37 = { alt: "" }
const _hoisted_38 = { class: "goal-icon" }
const _hoisted_39 = { alt: "" }
const _hoisted_40 = { class: "goal-icon" }
const _hoisted_41 = { alt: "" }
const _hoisted_42 = { class: "statistics" }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = {
  key: 0,
  class: "statistics-sen"
}
const _hoisted_45 = { class: "statistics-sen-top" }
const _hoisted_46 = { class: "statistics-sen-bottom flexcenter" }
const _hoisted_47 = { class: "statistics-sen-bottom-left" }
const _hoisted_48 = { class: "statistics-sen-bottom-right" }
const _hoisted_49 = { class: "details" }
const _hoisted_50 = { class: "details-tab flexcenter" }
const _hoisted_51 = {
  key: 0,
  class: "details-txt"
}
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { class: "details-txt-left" }
const _hoisted_54 = { alt: "" }
const _hoisted_55 = { class: "details-txt-cen" }
const _hoisted_56 = { class: "details-txt-cen-left ovehide" }
const _hoisted_57 = {
  key: 1,
  class: "major"
}
const _hoisted_58 = { class: "major-cen" }
const _hoisted_59 = { class: "major-cen-one" }
const _hoisted_60 = { key: 0 }
const _hoisted_61 = { class: "major-cen-one-nam" }
const _hoisted_62 = { class: "major-cen-one-nam-text" }
const _hoisted_63 = { alt: "" }
const _hoisted_64 = { class: "major-cen-one-nam-text" }
const _hoisted_65 = { alt: "" }
const _hoisted_66 = { class: "major-cen-two" }
const _hoisted_67 = { class: "major-cen-boran" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "major-cen-boran-xt" }, null, -1 /* HOISTED */))
const _hoisted_69 = {
  key: 0,
  class: "major-cen-boran-rangin"
}
const _hoisted_70 = { key: 1 }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "major-cen-boran-xt" }, null, -1 /* HOISTED */))
const _hoisted_72 = { class: "major-cen-three" }
const _hoisted_73 = { key: 0 }
const _hoisted_74 = { class: "major-cen-one-nam" }
const _hoisted_75 = { alt: "" }
const _hoisted_76 = { class: "major-cen-one-nam-text" }
const _hoisted_77 = { alt: "" }
const _hoisted_78 = { class: "major-cen-one-nam-text" }
const _hoisted_79 = { class: "rule" }
const _hoisted_80 = { alt: "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_circle = _resolveComponent("van-circle")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.matchAD && $setup.th != 'th')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("img", {
            class: "adimg",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.toLocationBrowser($setup.matchAD.url))),
            src: $setup.matchAD.img,
            alt: ""
          }, null, 8 /* PROPS */, _hoisted_3)
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("p", null, _toDisplayString($setup.team1), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("p", null, _toDisplayString($setup.team2), 1 /* TEXT */),
        _hoisted_8
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("span", null, _toDisplayString($setup.atackHome), 1 /* TEXT */),
          _createVNode(_component_van_circle, {
            "current-rate": $setup.atackallscr,
            "onUpdate:current-rate": _cache[1] || (_cache[1] = ($event: any) => (($setup.atackallscr) = $event)),
            rate: $setup.atackallscr,
            size: "40px",
            color: $setup.atackHome == 0 && $setup.atackAway == 0 ? '#f2f2f2' : '#358bf3',
            "stroke-width": 100,
            speed: 100,
            "layer-color": $setup.atackHome == 0 && $setup.atackAway == 0 ? '#f2f2f2' : '#FC2D33'
              
          }, null, 8 /* PROPS */, ["current-rate", "rate", "color", "layer-color"]),
          _createElementVNode("span", null, _toDisplayString($setup.atackAway), 1 /* TEXT */)
        ]),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('match.matchzg')), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("span", null, _toDisplayString($setup.dangerousatackHome), 1 /* TEXT */),
          _createVNode(_component_van_circle, {
            "current-rate": $setup.dangscr,
            "onUpdate:current-rate": _cache[2] || (_cache[2] = ($event: any) => (($setup.dangscr) = $event)),
            rate: $setup.dangscr,
            size: "40px",
            color: $setup.dangerousatackHome == 0 && $setup.dangerousatackAway == 0
            ? '#f2f2f2'
            : '#358bf3'
            ,
            "stroke-width": 100,
            speed: 100,
            "layer-color": $setup.dangerousatackHome == 0 && $setup.dangerousatackAway == 0
    ? '#f2f2f2'
    : '#FC2D33'
    
          }, null, 8 /* PROPS */, ["current-rate", "rate", "color", "layer-color"]),
          _createElementVNode("span", null, _toDisplayString($setup.dangerousatackAway), 1 /* TEXT */)
        ]),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('match.matchwxjg')), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("span", null, _toDisplayString($setup.ballPossessionHome), 1 /* TEXT */),
          _createVNode(_component_van_circle, {
            "current-rate": $setup.ballPosscr,
            "onUpdate:current-rate": _cache[3] || (_cache[3] = ($event: any) => (($setup.ballPosscr) = $event)),
            rate: $setup.ballPosscr,
            size: "40px",
            color: $setup.ballPossessionHome == 0 && $setup.ballPossessionAway == 0
            ? '#f2f2f2'
            : '#358bf3'
            ,
            "stroke-width": 100,
            speed: 100,
            "layer-color": $setup.ballPossessionHome == 0 && $setup.ballPossessionAway == 0
    ? '#f2f2f2'
    : '#FC2D33'
    
          }, null, 8 /* PROPS */, ["current-rate", "rate", "color", "layer-color"]),
          _createElementVNode("span", null, _toDisplayString($setup.ballPossessionAway), 1 /* TEXT */)
        ]),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('match.matchkql')), 1 /* TEXT */)
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _withDirectives(_createElementVNode("img", _hoisted_19, null, 512 /* NEED_PATCH */), [
            [_directive_lazy, $setup.ICON1]
          ]),
          _createElementVNode("span", null, _toDisplayString($setup.huangPaiHome), 1 /* TEXT */)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _withDirectives(_createElementVNode("img", _hoisted_21, null, 512 /* NEED_PATCH */), [
            [_directive_lazy, $setup.ICON2]
          ]),
          _createElementVNode("span", null, _toDisplayString($setup.hongPaiHome), 1 /* TEXT */)
        ]),
        _createElementVNode("div", _hoisted_22, [
          _withDirectives(_createElementVNode("img", _hoisted_23, null, 512 /* NEED_PATCH */), [
            [_directive_lazy, $setup.ICON3]
          ]),
          _createElementVNode("span", null, _toDisplayString($setup.jiaoqiuHome), 1 /* TEXT */)
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('match.matchszqm')), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("span", null, _toDisplayString($setup.shengzhenHome), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("p", {
                  style: _normalizeStyle({ width: $setup.liveSheZhengHome + '%' })
                }, null, 4 /* STYLE */)
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("p", {
                  style: _normalizeStyle({ width: $setup.liveSheZhengAway + '%' })
                }, null, 4 /* STYLE */)
              ])
            ]),
            _createElementVNode("span", null, _toDisplayString($setup.shengzhenAway), 1 /* TEXT */)
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('match.matchspqm')), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("span", null, _toDisplayString($setup.shengPianHome), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("p", {
                  style: _normalizeStyle({ width: $setup.liveShePianHome + '%' })
                }, null, 4 /* STYLE */)
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("p", {
                  style: _normalizeStyle({ width: $setup.liveShePianAway + '%' })
                }, null, 4 /* STYLE */)
              ])
            ]),
            _createElementVNode("span", null, _toDisplayString($setup.shengPianAway), 1 /* TEXT */)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("span", null, _toDisplayString($setup.huangPaiAway), 1 /* TEXT */),
          _withDirectives(_createElementVNode("img", _hoisted_37, null, 512 /* NEED_PATCH */), [
            [_directive_lazy, $setup.ICON1]
          ])
        ]),
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("span", null, _toDisplayString($setup.hongPaiAway), 1 /* TEXT */),
          _withDirectives(_createElementVNode("img", _hoisted_39, null, 512 /* NEED_PATCH */), [
            [_directive_lazy, $setup.ICON2]
          ])
        ]),
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("span", null, _toDisplayString($setup.jiaoqiuAway), 1 /* TEXT */),
          _withDirectives(_createElementVNode("img", _hoisted_41, null, 512 /* NEED_PATCH */), [
            [_directive_lazy, $setup.ICON3]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_42, [
      ($setup.statistics)
        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.statsall, (item, i) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: item }, [
                (item != '' && item != null && item != undefined)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("span", null, _toDisplayString(item.home), 1 /* TEXT */),
                        _createElementVNode("span", null, _toDisplayString($setup.DataUtils.getType(item.type)), 1 /* TEXT */),
                        _createElementVNode("span", null, _toDisplayString(item.away), 1 /* TEXT */)
                      ]),
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("div", _hoisted_47, [
                          _createElementVNode("p", {
                            style: _normalizeStyle({
                  width: $setup.getPercent(item.away, item.home) + '%',
                })
                          }, null, 4 /* STYLE */)
                        ]),
                        _createElementVNode("div", _hoisted_48, [
                          _createElementVNode("p", {
                            style: _normalizeStyle({
                  width: $setup.getPercent(item.home, item.away) + '%',
                })
                          }, null, 4 /* STYLE */)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ], 64 /* STABLE_FRAGMENT */))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", {
        class: "statistics-show",
        onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.statistics = !$setup.statistics))
      }, [
        _createElementVNode("span", null, _toDisplayString($setup.statistics ? $setup.t('me.sq') : $setup.t('me.qbtj')), 1 /* TEXT */),
        ($setup.statistics)
          ? (_openBlock(), _createBlock(_component_van_icon, {
              key: 0,
              name: "arrow-up"
            }))
          : (_openBlock(), _createBlock(_component_van_icon, {
              key: 1,
              name: "arrow-down"
            }))
      ])
    ]),
    _createElementVNode("div", _hoisted_49, [
      _createElementVNode("div", _hoisted_50, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", {
            onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.detailsshow = !$setup.detailsshow)),
            style: _normalizeStyle({
            color: $setup.detailsshow ? '#fff' : $setup.primaryColor,
            'background-color': $setup.detailsshow ? $setup.primaryColor : '#fff',
          })
          }, _toDisplayString(_ctx.$t('play.textLive')), 5 /* TEXT, STYLE */),
          _createElementVNode("li", {
            onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.detailsshow = !$setup.detailsshow)),
            style: _normalizeStyle({
            color: $setup.detailsshow ? $setup.primaryColor : '#fff',
            'background-color': !$setup.detailsshow ? $setup.primaryColor : '#fff',
          })
          }, _toDisplayString(_ctx.$t('match.matchzysj')), 5 /* TEXT, STYLE */)
        ])
      ]),
      ($setup.detailsshow)
        ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
            ($setup.tlive.length > 0)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_52, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tlive, (item, index) => {
                    return (_openBlock(), _createElementBlock("li", { key: index }, [
                      _createElementVNode("div", _hoisted_53, [
                        _withDirectives(_createElementVNode("img", _hoisted_54, null, 512 /* NEED_PATCH */), [
                          [_directive_lazy, $setup.getIcon(item.type)]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_55, [
                        _createElementVNode("span", _hoisted_56, _toDisplayString(item.data), 1 /* TEXT */),
                        _createElementVNode("span", {
                          class: "details-txt-cen-right",
                          style: _normalizeStyle({ 'background-color': $setup.getColor(item.position) })
                        }, null, 4 /* STYLE */)
                      ])
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true),
      (!$setup.detailsshow)
        ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
            _createElementVNode("div", _hoisted_58, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.incidents, (item, index) => {
                return (_openBlock(), _createElementBlock("ul", {
                  key: index,
                  class: "flexcenter"
                }, [
                  _createElementVNode("li", _hoisted_59, [
                    ($setup.majortype(item.type) != 3)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                          _createElementVNode("div", _hoisted_61, [
                            ($setup.majortype(item.type) == 1 && item.position == 1)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createElementVNode("div", _hoisted_62, [
                                    _createElementVNode("p", null, _toDisplayString(item.player_name), 1 /* TEXT */)
                                  ]),
                                  _withDirectives(_createElementVNode("img", _hoisted_63, null, 512 /* NEED_PATCH */), [
                                    [_directive_lazy, $setup.getIcon(item.type)]
                                  ])
                                ], 64 /* STABLE_FRAGMENT */))
                              : ($setup.majortype(item.type) == 2 && item.position == 1)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createElementVNode("div", _hoisted_64, [
                                      _createElementVNode("p", null, _toDisplayString(item.in_player_name), 1 /* TEXT */),
                                      _createElementVNode("p", null, _toDisplayString(item.out_player_name), 1 /* TEXT */)
                                    ]),
                                    _withDirectives(_createElementVNode("img", _hoisted_65, null, 512 /* NEED_PATCH */), [
                                      [_directive_lazy, $setup.getIcon(item.type)]
                                    ])
                                  ], 64 /* STABLE_FRAGMENT */))
                                : _createCommentVNode("v-if", true)
                          ])
                        ]))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _createElementVNode("li", _hoisted_66, [
                    _createElementVNode("div", _hoisted_67, [
                      _hoisted_68,
                      ($setup.majortype(item.type) != 3)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_69, _toDisplayString(item.time), 1 /* TEXT */))
                        : (_openBlock(), _createElementBlock("p", _hoisted_70, _toDisplayString($setup.DataUtils.getType(item.type)), 1 /* TEXT */)),
                      _hoisted_71
                    ])
                  ]),
                  _createElementVNode("li", _hoisted_72, [
                    ($setup.majortype(item.type) != 3)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                          _createElementVNode("div", _hoisted_74, [
                            ($setup.majortype(item.type) == 1 && item.position == 2)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _withDirectives(_createElementVNode("img", _hoisted_75, null, 512 /* NEED_PATCH */), [
                                    [_directive_lazy, $setup.getIcon(item.type)]
                                  ]),
                                  _createElementVNode("div", _hoisted_76, [
                                    _createElementVNode("p", null, _toDisplayString(item.player_name), 1 /* TEXT */)
                                  ])
                                ], 64 /* STABLE_FRAGMENT */))
                              : ($setup.majortype(item.type) == 2 && item.position == 2)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _withDirectives(_createElementVNode("img", _hoisted_77, null, 512 /* NEED_PATCH */), [
                                      [_directive_lazy, $setup.getIcon(item.type)]
                                    ]),
                                    _createElementVNode("div", _hoisted_78, [
                                      _createElementVNode("p", null, _toDisplayString(item.in_player_name), 1 /* TEXT */),
                                      _createElementVNode("p", null, _toDisplayString(item.out_player_name), 1 /* TEXT */)
                                    ])
                                  ], 64 /* STABLE_FRAGMENT */))
                                : _createCommentVNode("v-if", true)
                          ])
                        ]))
                      : _createCommentVNode("v-if", true)
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_79, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.ICONS_NAME_DATA, (item, index) => {
        return _createElementVNode("div", {
          class: "rule-cen",
          key: index
        }, [
          _withDirectives(_createElementVNode("img", _hoisted_80, null, 512 /* NEED_PATCH */), [
            [_directive_lazy, item.icon]
          ]),
          _createElementVNode("span", null, _toDisplayString(item.name), 1 /* TEXT */)
        ])
      }), 64 /* STABLE_FRAGMENT */))
    ])
  ]))
}